import { render, staticRenderFns } from "./DmBatchProfileDetails.vue?vue&type=template&id=5d1ba314&scoped=true&"
import script from "./DmBatchProfileDetails.vue?vue&type=script&lang=js&"
export * from "./DmBatchProfileDetails.vue?vue&type=script&lang=js&"
import style0 from "./DmBatchProfileDetails.vue?vue&type=style&index=0&id=5d1ba314&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1ba314",
  null
  
)

export default component.exports